import React, { useContext, useEffect, useState, lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Sidebar from './components/Shared/SideBar/SideBar';
import Header from './components/Shared/Header/Header';
import { UserContext } from './UserContext';
import { UserDTO } from './dto/UserDTO';
import { browserLocalPersistence, browserSessionPersistence, getAuth, onIdTokenChanged, setPersistence } from 'firebase/auth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserService } from './services/UserService';
import { CircularProgress } from '@mui/material';
import { auth } from './firebase/firebaseConfig';
import { WebSettingsProvider } from './context/WebSettingsContext';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from './pages/Login/Login';
import Publishers from './pages/Publishers/Publishers';
import PublisherForm from './pages/Publishers/PublisherForm';
import NotAuthorized from './pages/NotAuthorized/NotAuthorized';
import Transactions from './pages/Transactions/Transactions';
import Schools from './pages/Schools/Schools';
import SchoolForm from './pages/Schools/SchoolForm';
import Books from './pages/Books/Books';
import BookForm from './pages/Books/BookForm';
import Batches from './pages/Batches/Batches';
import BatchesForm from './pages/Batches/BatchesForm';
import AccessCodeList from './pages/Batches/AccessCodeList';
import Users from './pages/Users/Users';
import UserForm from './pages/Users/UserForm';
import Categories from './pages/Categories/Categories';
import CategoriesForm from './pages/Categories/CategoriesForm';
import Announcements from './pages/Announcements/Announcements';
import Grades from './pages/Grades/Grades';
import GradesForm from './pages/Grades/GradesForm';
import AnnouncementsForm from './pages/Announcements/AnnouncementsForm';
import FAQs from './pages/FAQs/FAQs';
import FAQForm from './pages/FAQs/FAQForm';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import Privacy from './pages/Privacy/Privacy';
import Help from './pages/Help/Help';
import Description from './pages/Description/Description';
import ReportsMobile from './pages/Reports/ReportMobile';
import ReportsWebsite from './pages/Reports/ReportWeb';
import AdminAccounts from './pages/AdminAccounts/AdminAccounts';
import AdminAccountsForm from './pages/AdminAccounts/AdminAccountsForm';
import ContactUs from './pages/ContactUs/ContactUs';
import BannerSlides from './pages/BannerSlides/BannerSlides';
import BannerSlideForm from './pages/BannerSlides/BannerSlidesForm';
import ContactDetails from './pages/ContactDetails/ContactDetails';

const App: React.FC = () => {
  const { user, setUser, loggedIn, setLoggedIn } = useContext(UserContext);

  const [isOnline, setIsOnline] = useState(true);
  const [loading, setLoading] = useState(true);

  const { rememberMe } = useContext(UserContext);
  if (rememberMe) {
  }
  const navigate = useNavigate()
  const location = useLocation();

  const hasAccess = (role: string, path: string) => {
    switch (role) {
      case 'admin':
        return true;
      case 'editor':
        return !['/adminaccounts', '/reports-website', '/reports-mobile', '/contactus'].includes(path);
      case 'sales':
        return ['/reports-website', '/reports-mobile', '/users'].includes(path);
      default:
        return false;
    }
  };



  const getPageTitle = (path: string) => {

    if (path.startsWith('/publishers/edit/')) {
      return 'Edit Publisher';
    } else if (path.startsWith('/schools/edit/')) {
      return 'Edit Institution';
    } else if (path.startsWith('/schools/view/')) {
      return 'Institution Details';

    } else if (path.startsWith('/publishers/view/')) {
      return 'Publisher Details';
    }
    else if (path.startsWith('/transactions')) {
      return 'Transactions';
    }
    else if (path.startsWith('/books/edit/')) {
      return 'Edit Book';
    } else if (path.startsWith('/users/edit/')) {
      return 'Edit User';
    } else if (path.startsWith('/users/view/')) {
      return 'User Details';
    } else if (path.startsWith('/categories/edit/')) {
      return 'Edit Category';
    }
    else if (path.startsWith('/grades/edit/')) {
      return 'Edit Grade';
    }
    else if (path.startsWith('/announcements/edit/')) {
      return 'Edit Announcement';
    }
    else if (path.startsWith('/announcements/view/')) {
      return 'Announcement Details';
    }
    else if (path.startsWith('/adminaccounts/edit/')) {
      return 'Edit Account';
    }
    else if (path.startsWith('/categories/view/')) {
      return 'Category Details';
    }
    else if (path.startsWith('/grades/view/')) {
      return 'Grade Details';
    } else if (path.startsWith('/accesscodes')) {
      return 'Access Codes List';
    } else if (path.startsWith('/batches/view/')) {
      return 'Batch Details';
    } else if (path.startsWith('/batches/edit/')) {
      return 'Edit Batch';
    } else if (path.startsWith('/books/view/')) {
      return 'Book Details';
    } else if (path.startsWith('/books/edit/')) {
      return 'Book Details';
    } else if (path.startsWith('/contactus')) {
      return 'Contact Us';
    } else if (path.startsWith('/adminaccounts/view/')) {
      return 'Account Details';
    } else if (path.startsWith('/reports-website')) {
      return 'Reports Website';
    } else if (path.startsWith('/reports-mobile')) {
      return 'Reports Mobile  ';
    } else if (path.startsWith('/contactDetails')) {
      return 'Contact Details ';
    }else if (path.startsWith('/banner-slides')) {
      return 'Banner Slides ';
    }else if (path.startsWith('/description')) {
      return 'Description ';
    }


    




    switch (path) {
      case '/dashboard':
        return 'Dashboard';

      case '/publishers':
        return 'Publishers';
      case '/publishers/add':
        return 'Create Publisher';
      case '/publishers/view/:id':
        return 'Publisher Details';


      case '/faq':
        return 'FAQs';
      case '/faq/add':
        return 'Create FAQ';
      case '/faq/view/:id':
        return 'FAQ Details';
        
      case '/terms':
        return 'Terms & Conditions';
      case '/privacy':
        return 'Privacy Policy';
        
      case '/help':
        return 'Help & Support';
          
      case '/schools':
        return 'Institutions';
      case '/schools/add':
        return 'Create Institution';

      case '/books':
        return 'Books';
      case '/batches':
        return 'Batches';
      case '/books/add':
        return 'Create Book';

      case '/batches/add':
        return 'Create batch';

      case '/users':
        return 'Users';
      case '/users/add':
        return 'Create User';

      case '/categories':
        return 'Categories';
      case '/categories/add':
        return 'Create Category';

      case '/grades':
        return 'Grades';
      case '/grades/add':
        return 'Create Grade';

      case '/announcements':
        return 'Announcements';
      case '/announcements/add':
        return 'Create Announcement';

        case '/banner-slides':
          return 'Banner Details';
        case '/banner-slides/add':
          return 'Create Banner ';
  

      case '/adminaccounts':
        return 'Admin Accounts';

      case '/adminaccounts/add':
        return 'Create Account';
      case '/adminaccounts/edit':
        return 'Edit Account';



      default:
        return '';
    }
  };

  const pageTitle = getPageTitle(location.pathname);

  const handleTokenChange = () => {
    const auth = getAuth();
    return onIdTokenChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const userInfo = await UserService.getUser();
          if (user === null || user._id !== userInfo._id) {
            setUser(userInfo);
            setLoggedIn(true)
          }
        } catch (error) {
          console.error("Error updating token or user:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    const unsubscribe = handleTokenChange();

    return () => {
      unsubscribe();
    };
  }, []);


  useEffect(() => {
    const handleStorageChange = async (event: StorageEvent) => {
      const rememberMeValue = localStorage.getItem('rememberMe') === 'true';

      if (event.key === 'logout' && rememberMeValue && event.newValue) {
        setUser(null);
        setLoggedIn(false);
        navigate("~/");
        const auth = getAuth();
        await auth.signOut();
      }
    };


    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  useEffect(() => {
    const rememberMe = localStorage.getItem("rememberMe");
    if (rememberMe === "true") {
      // If Remember Me was checked, set persistence to local
      setPersistence(auth, browserLocalPersistence);
    } else {
      // If Remember Me was not checked, use session persistence
      setPersistence(auth, browserSessionPersistence);
    }
  }, []);


  useEffect(() => {
    if (!loading) {
      if (user) {
        if (location.pathname === "/login" && user.active && ["admin", "sales", "editor"].includes(user.role)) {
          if (user.role === "sales") {
            navigate("/reports", { replace: true })
            return;
          }
          navigate('/dashboard', { replace: true })
        }
        if (location.pathname === "/" && user.active && ["admin", "sales", "editor"].includes(user.role)) {
          if (user.role === 'sales') {
            navigate("/reports", { replace: true })
            return
          }
          navigate('/dashboard')
        }
      }
    }
  }, [user?.role, location.pathname]);

  return (
    <WebSettingsProvider>
      <div className="App">
        <ToastContainer style={{ width: '546px', height: '74px', position: 'fixed', top: '124px', right: '26px' }} />
        {!loading ? (
          loggedIn && user?.active && ["admin", "sales", "editor"].includes(user.role) ? (
            <div className="main-container">
              <Sidebar role={user?.role || ''} />
              <div className='content-container'>
                <div className='header'>
                  <Header pageTitle={pageTitle} username={user?.fullname} role={user?.role} isOnline={isOnline} />
                </div>
                <div className="content">
                  
                    <Routes>
                      <Route path="/" element={<Dashboard />} /> 
                      <Route path="/login" element={<Login setLoggedIn={setLoggedIn} />} />

                      <Route path="/dashboard" element={<Dashboard />} />

                      {hasAccess(user?.role ?? '', '/publishers') ? (
                        <>
                          <Route path="/publishers" element={<Publishers />} />
                          <Route path="/publishers/add" element={<PublisherForm mode="add" />} />
                          <Route path="/publishers/edit/:id" element={<PublisherForm mode="edit" />} />
                          <Route path="/publishers/view/:id" element={<PublisherForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/publishers/*" element={<NotAuthorized />} />

                      }

                      {hasAccess(user?.role ?? '', '/transactions') ? (
                        <>
                          <Route path="/transactions" element={<Transactions />} />
                        </>
                      ) :
                        <Route path="/transactions/*" element={<NotAuthorized />} />

                      }

                      {hasAccess(user?.role ?? '', '/schools') ? (
                        <>
                          <Route path="/schools" element={<Schools />} />
                          <Route path="/schools/add" element={<SchoolForm mode="add" />} />
                          <Route path="/schools/edit/:id" element={<SchoolForm mode="edit" />} />
                          <Route path="/schools/view/:id" element={<SchoolForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/schools/*" element={<NotAuthorized />} />
                      }
                      {hasAccess(user?.role ?? '', '/books') ? (
                        <>
                          <Route path="/books" element={<Books />} />
                          <Route path="/books/add" element={<BookForm mode="add" />} />
                          <Route path="/books/edit/:id" element={<BookForm mode="edit" />} />
                          <Route path="/books/view/:id" element={<BookForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/books/*" element={<NotAuthorized />} />
                      }
                      {hasAccess(user?.role ?? '', '/batches') ? (
                        <>
                          <Route path="/batches" element={<Batches />} />
                          <Route path="/batches/add" element={<BatchesForm mode="add" />} />
                          <Route path="/batches/edit/:id" element={<BatchesForm mode="edit" />} />
                          <Route path="/batches/view/:id" element={<BatchesForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/batches/*" element={<NotAuthorized />} />
                      }

                      <Route path="/accesscodes/:id/:lang" element={<AccessCodeList />} />
                      {hasAccess(user?.role ?? '', '/users') ?(
                        <>
                          <Route path="/users" element={<Users />} />
                          <Route path="/users/add" element={<UserForm mode="add" />} />
                          <Route path="/users/edit/:id" element={<UserForm mode="edit" />} />
                          <Route path="/users/view/:id" element={<UserForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/users/*" element={<NotAuthorized />} />

                      }
                      {hasAccess(user?.role ?? '', '/categories') ? (
                        <>
                          <Route path="/categories" element={<Categories />} />
                          <Route path="/categories/add" element={<CategoriesForm mode="add" />} />
                          <Route path="/categories/edit/:id" element={<CategoriesForm mode="edit" />} />
                          <Route path="/categories/view/:id" element={<CategoriesForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/categories/*" element={<NotAuthorized />} />
                      }
                      {hasAccess(user?.role ?? '', '/grades') ? (
                        <>
                          <Route path="/grades" element={<Grades />} />
                          <Route path="/grades/add" element={<GradesForm mode="add" />} />
                          <Route path="/grades/edit/:id" element={<GradesForm mode="edit" />} />
                          <Route path="/grades/view/:id" element={<GradesForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/grades/*" element={<NotAuthorized />} />
                      }
                      {hasAccess(user?.role ?? '', '/announcements') ? (
                        <>
                          <Route path="/announcements" element={<Announcements />} />
                          <Route path="/announcements/add" element={<AnnouncementsForm mode="add" />} />
                          <Route path="/announcements/edit/:id" element={<AnnouncementsForm mode="edit" />} />
                          <Route path="/announcements/view/:id" element={<AnnouncementsForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/announcements/*" element={<NotAuthorized />} />
                      }

                      {hasAccess(user?.role ?? '', '/faq') ? (
                        <>
                          <Route path="/faq" element={<FAQs />} />
                          <Route path="/faq/add" element={<FAQForm mode="add" />} />
                          <Route path="/faq/edit/:id" element={<FAQForm mode="edit" />} />
                          <Route path="/faq/view/:id" element={<FAQForm mode="view" />} />
                        </>
                      ) :
                        <Route path="/faq/*" element={<NotAuthorized />} />
                      }

                      {hasAccess(user?.role ?? '', '/terms') ? (
                        <>
                          <Route path="/terms" element={<TermsAndConditions />} />
                
                        </>
                      ) :
                        <Route path="/terms/*" element={<NotAuthorized />} />
                      }

                    {hasAccess(user?.role ?? '', '/privacy') ? (
                              <>
                                <Route path="/privacy" element={<Privacy />} />
                
                              </>
                            ) :
                              <Route path="/privacy/*" element={<NotAuthorized />} />
                            }

                    {hasAccess(user?.role ?? '', '/help') ? (
                              <>
                                <Route path="/help" element={<Help />} />
                
                              </>
                            ) :
                              <Route path="/help/*" element={<NotAuthorized />} />
                            }
                              

                          {hasAccess(user?.role ?? '', '/description') ? (
                            <>
                              <Route path="/description" element={<Description />} />
                              <Route path="/description/add" element={<AnnouncementsForm mode="add" />} />
                              <Route path="/description/edit/:id" element={<AnnouncementsForm mode="edit" />} />
                              <Route path="/description/view/:id" element={<AnnouncementsForm mode="view" />} />
                            </>
                          ) :
                            <Route path="/description/*" element={<NotAuthorized />} />
                          }
                          {hasAccess(user?.role ?? '', '/reports-mobile') ? (
                            <Route path="/reports-mobile" element={<ReportsMobile />} />
                          ) :
                            <Route path="/reports-mobile/*" element={<NotAuthorized />} />

                          }
                          {hasAccess(user?.role ?? '', '/reports-website') ? (
                            <Route path="/reports-website" element={<ReportsWebsite />} />
                          ) :
                            <Route path="/reports-website/*" element={<NotAuthorized />} />

                          }
                          {hasAccess(user?.role ?? '', '/adminaccounts') ? (
                            <>
                              <Route path="/adminaccounts" element={<AdminAccounts />} />
                              <Route path="/adminaccounts/add" element={<AdminAccountsForm mode="add" />} />
                              <Route path="/adminaccounts/edit/:id" element={<AdminAccountsForm mode="edit" />} />
                              <Route path="/adminaccounts/view/:id" element={<AdminAccountsForm mode="view" />} />
                            </>
                          ) :

                            <Route path="/contactus/*" element={<NotAuthorized />} />
                          }
                          {hasAccess(user?.role ?? '', '/contactus') ? (
                            <>
                              <Route path="/contactus" element={<ContactUs />} />
                            </>
                          ) :
                            <Route path="/adminaccounts/*" element={<NotAuthorized />} />
                          }
                           {hasAccess(user?.role ?? '', '/banner-slides') ? (
                            <>
                              <Route path="/banner-slides" element={<BannerSlides />} />
                              <Route path="/banner-slides/add" element={<BannerSlideForm mode="add" />} />
                              <Route path="/banner-slides/edit/:id" element={<BannerSlideForm mode="edit" />} />
                              <Route path="/banner-slides/view/:id" element={<BannerSlideForm mode="view" />} />
                            </>
                          ) :
                            <Route path="/banner-slides/*" element={<NotAuthorized />} />
                          }

                          {hasAccess(user?.role ?? '', '/contactDetails') ? (
                            <>
                              <Route path="/contactDetails" element={<ContactDetails/>} />
                            </>
                          ) :
                            <Route path="/contactDetails/*" element={<NotAuthorized />} />
                          }
                          <Route path="/notauthorized" element={<NotAuthorized />} />

                        </Routes>
                  
                </div>
              </div>
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login setLoggedIn={setLoggedIn} />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: "center", justifyContent: 'center' }}>
            <CircularProgress />
          </div>
        )}
      </div>
    </WebSettingsProvider>
  );
};

const AppWrapper: React.FC = () => {

  const [user, setUser] = useState<UserDTO | null>(null);
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [loggedIn, setLoggedIn] = useState(false);

  const logOut = async () => {
    setUser(null);
    setLoggedIn(false)
    const auth = getAuth();
    await auth.signOut();
    localStorage.setItem('logout', Date());
  };
  return (
    <UserContext.Provider value={{ user, setUser, rememberMe, setRememberMe, logOut, loggedIn, setLoggedIn }}>
      <Router>
        <App />
      </Router>
    </UserContext.Provider>
  );
};

export default AppWrapper;


